

















import { Component, Prop, Vue } from "vue-property-decorator";
import { eventService } from "../services/EventService";

@Component({
  components: {}
})
export default class DialogConfirm extends Vue {
  @Prop({ type: String, default: "DialogConfirm-Cancel" })
  cancelEvent: any | string;

  @Prop({ type: String, default: "DialogConfirm-Accept" })
  acceptEvent: any | string;

  @Prop({ type: Boolean, default: false })
  visible: boolean = false;


  @Prop({ type: String, default: "Confirmación" })
  title: any | string;

  @Prop({ type: String, default: "¿Desea realizar la operación?" })
  textConfirmation: any | string;

  destroyed(){
    eventService.off(this.cancelEvent);
    eventService.off(this.acceptEvent);
  }

  cancel() {
    eventService.emit(this.cancelEvent, null);
  }

  accept() {
    eventService.emit(this.acceptEvent, null);
  }
}
